// extracted by css-extract-rspack-plugin
export default {"triggerContents":"AllowedExceptions-module__triggerContents__VQdx3","descriptionText":"AllowedExceptions-module__descriptionText__p7JKZ"};